import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import Placeholder from '../../components/molecule/Placeholder';
import CardGrid from '../../components/organism/CardGrid';
import InfoCard from '../../components/molecule/Cards/InfoCard';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getCompanies, libraryLoaded, companyBase } from '../../modules/Company';
import { toast } from 'react-toastify';

const ENT_PLACEHOLDER = require('../../assets/entity_placeholder.jpg').default;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  // height: 100%;
`
const CardGridStyled = styled(CardGrid)`

`
const Scrollable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 115px;
`

const PlaceholderStyled = styled(Placeholder)`
  margin: 100px auto;
`

const Header = styled.div`
  margin: 20px;
  font-size: 20px;
  font-weight: 600;
`

class CompanyLibrary extends Component {
  async componentDidMount() {
    const { getCompanies, companyBase } = this.props;

    try {
      companyBase();
      await getCompanies();
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  renderCard = (item, index) => {
    const { history } = this.props;
    return (
      <InfoCard
        key={`${index}-${item.name}`}
        image={item.logo ? item.logo : ENT_PLACEHOLDER}
        header={item.name}
        subtext1={`${item.user_count} user(s)`}
        subtext2={`${item.cohort_count} cohort(s)`}
        onClick={() => history.push(`/digital-coaching/${item.id}`, { company: item })}
      />
    )
  }

  render() {
    const { companyState } = this.props

    return (
      <Container>
        <Scrollable>
          {
            (
              companyState.companies.length <= 0 &&
              !companyState.isLoading &&
              companyState.query === ''
            ) ? (
              <PlaceholderStyled title="No Companies Found" />
            ) : (
              <>
                <Header>Companies</Header>
                <CardGridStyled
                  data={companyState.companies}
                  renderItem={(item,index) => this.renderCard(item,index)}
                  isLoading={companyState.isLoading}
                />
              </>
            ) 
          }
        </Scrollable>
      </Container>
    )
  }
}

CompanyLibrary.propTypes = {
};

CompanyLibrary.defaultProps = {
};

function mapStateToProps(state) {
  return {
    companyState: state.companyState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getCompanies: getCompanies,
    libraryLoaded: libraryLoaded,
    companyBase: companyBase
  }, dispatch)
}


export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CompanyLibrary);